import Vue from 'vue';
import Vuex from 'vuex';
import { IAppState } from './modules/ModuleApp';
import { IUserState } from './modules/ModuleUser';
import { ITagsViewState } from './modules/ModuleTagsView';
import { IErrorLogState } from './modules/ModuleErrorLog';
import { IPermissionState } from './modules/ModulePermission';
import { ISettingsState } from './modules/ModuleSettings';
import { IInquery } from './modules/ModuleInquery';

Vue.use(Vuex);

export interface IRootState {
	app: IAppState;
	user: IUserState;
	tagsView: ITagsViewState;
	errorLog: IErrorLogState;
	permission: IPermissionState;
	settings: ISettingsState;
	inquery: IInquery;
	currentChanged: any;
	roleBased: any;
	isShow: any;
}

// Declare empty store first, dynamically register all modules later.
export default new Vuex.Store<any>({
	state: {
		currentChanged: '',
		roleBased: false,
		isShow: true,
		isManNav: false,
		isShowHeader: true
	},
	mutations: {
		/**
		 * set current changed
		 *
		 * @param {any} state
		 * @param {any} changed
		 */
		setCurrentChanged(state, changed) {
			state.currentChanged = changed;
		},

		/**
		 * set role based
		 *
		 * @param {any} state
		 * @param {any} roleBased
		 */
		setRoleBased(state, roleBased) {
			state.roleBased = roleBased;
		},

		/**
		 * set handle show
		 *
		 * @param {any} state
		 */
		setHandleShow(state) {
			state.isShow = !state.isShow;
		},

		/**
		 * set container unfold
		 *
		 * @param {any} state
		 * @param {any} status
		 */
		setContainerUnfold(state, status) {
			state.isManNav = status;
		},

		/**
		 *  show header
		 *
		 * @param {any} state
		 * @param {any} value
		 */
		showHeader(state, value) {
			state.isShowHeader = value;
		}
	},
	actions: {},
	modules: {}
});
